import type { ValidatedKey } from '@festina-life/core'
import dayjs from 'dayjs'
import { useField } from 'formik'
import get from 'lodash-es/get'
import { useMemo } from 'react'

import { useFormikContext } from '../../hooks/useFormikContext'
import { useExistingValuesContext } from '../../theme/existingValuesContext'

export const useDateValueDifferenceCheck = (name: ValidatedKey) => {
  const [field] = useField(name)
  const {
    initialValues,
    status: { shouldShowChangesInForm },
  } = useFormikContext()

  const existingValue = useExistingValuesContext()?.getExistingValue?.(
    name,
  ) as string

  const initialValue = useMemo(
    () => get(initialValues, name),
    [initialValues, name],
  )

  return useMemo(() => {
    if (!shouldShowChangesInForm) {
      return undefined
    }

    const previous = existingValue ?? initialValue
    if (dayjs(field.value).isSame(previous)) {
      return 'identical'
    } else if (dayjs(field.value).isAfter(previous)) {
      return 'bigger'
    } else if (dayjs(field.value).isBefore(previous)) {
      return 'smaller'
    }
    return undefined
  }, [existingValue, field.value, initialValue, shouldShowChangesInForm])
}
